import { ImportOutlined, MoreOutlined, PlusOutlined } from '@ant-design/icons';
import { Button } from '@mm/components';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { Divider } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { BookDemoButton } from '../../../../../../common/buttons/BookDemoButton/BookDemoButton';
import PAGES_HEAD_CONTENT from '../../../../../../common/components/MetaData/constants';
import MetaData from '../../../../../../common/components/MetaData/MetaData';
import { AUTOMATIONS_UTM } from '../../../../../../dashboard/pages/XRayOnboarding/WebsiteReportSummary/constants';
import { EmailAnalytics } from '../../Analytics/EmailAnalytics/EmailAnalytics';
import { Menu } from '../AutomationEdit/DialogueEditor/NodeTypes/elements/NodeMenu/NodeMenu';
import styles from './AutomationHome.module.css';
import { AutomationIndex } from './AutomationIndex';
import { AutomationTemplateContainer } from './TemplateIndex/AutomationTemplateContainer';
import { TemplateGoButton } from './TemplateIndex/TemplateGoButton';

type Props = {
  className?: string;
};

export const AutomationHome = ({ className }: Props) => {
  const modalActions = useModalActions();

  const onImportAutomationClick = () => {
    modalActions.openImportAutomationModal();
  };

  const menu = [
    {
      disabled: false,
      children: (
        <div className={styles.menuItem}>
          {' '}
          <ImportOutlined className={styles.menuItemIcon} /> Import Automation
        </div>
      ),
      onClick: onImportAutomationClick,
    },
  ];

  return (
    <div className={classNames(className, styles.container)}>
      <MetaData
        title={PAGES_HEAD_CONTENT.AUTOMATIONS.title}
        description={PAGES_HEAD_CONTENT.AUTOMATIONS.meta.description}
      />
      <EmailAnalytics
        header="My Automations"
        headerRightChildren={
          <div className={styles.buttons}>
            <TemplateGoButton
              label="New Automation"
              leftIcon={<PlusOutlined />}
              css={{ button: styles.addAutomationButton }}
            />
            <BookDemoButton
              className={styles.demoButton}
              utm={AUTOMATIONS_UTM}
            />
            <Menu
              className={styles.menu}
              menu={menu}
              direction="bottom"
              menuButton={
                <Button
                  css={{ container: styles.menuButton }}
                  color="secondary"
                >
                  <MoreOutlined className={styles.moreIcon} />
                </Button>
              }
              css={{ menu: styles.nodeMenu }}
            />
          </div>
        }
        onlySummaryStats
        calendarTitle="Global Analytics"
        css={{
          container: styles.analyticsContainer,
          header: styles.analyticsHeader,
          box: styles.statBox,
          headerWitchChildren: styles.header,
          calendarTitle: styles.calendarTitle,
        }}
      />
      <Divider className={styles.divider} />
      <AutomationIndex className={styles.box} />
    </div>
  );
};
